var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslateSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4401 18.4154L22.0638 23.7713C22.4787 24.1664 22.4787 24.8071 22.0638 25.2023C21.6489 25.5975 20.9761 25.5975 20.5612 25.2023L14.1862 19.1309C13.7713 18.7357 13.7713 18.095 14.1862 17.6998L20.5612 11.6284C20.9761 11.2332 21.6489 11.2332 22.0638 11.6284C22.4787 12.0236 22.4787 12.6643 22.0638 13.0595L16.4401 18.4154Z",
    fill: "#26890D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6288 19.832C15.0513 19.832 14.5832 19.3563 14.5832 18.7695C14.5832 18.1827 15.0513 17.707 15.6288 17.707L35.4959 17.707C36.0734 17.707 36.5415 18.1827 36.5415 18.7695C36.5415 19.3563 36.0734 19.832 35.4959 19.832L15.6288 19.832Z",
    fill: "#26890D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3527 25.8095C27.9378 25.4143 27.9378 24.7736 28.3527 24.3784C28.7676 23.9832 29.4404 23.9832 29.8553 24.3784L36.2303 30.4498C36.6452 30.845 36.6452 31.4857 36.2303 31.8809L29.8553 37.9523C29.4404 38.3475 28.7676 38.3475 28.3527 37.9523C27.9378 37.5571 27.9378 36.9164 28.3527 36.5213L33.9764 31.1654L28.3527 25.8095Z",
    fill: "#26890D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9208 31.875C14.3433 31.875 13.8752 31.3993 13.8752 30.8125C13.8752 30.2257 14.3433 29.75 14.9208 29.75L34.7879 29.75C35.3653 29.75 35.8335 30.2257 35.8335 30.8125C35.8335 31.3993 35.3653 31.875 34.7879 31.875L14.9208 31.875Z",
    fill: "#26890D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateSwapIcon);
export default __webpack_public_path__ + "static/media/TranslateSwapIcon.1365cade9876018c8d5d326b8f155dab.svg";
export { ForwardRef as ReactComponent };